<template>
  <div class="container">
    <h1>Batch Score CSV Upload</h1>
    <p>Upload a CSV file to score multiple loan applicants at once. Remember the column names in your uploaded file must be the exact model field names. An example CSV file is available
      <a href="/static/batch-example.csv">here</a> for reference. It is suggested that a file not be greater than 50 records at a time.</p>
    <p>Please see the
      <router-link to="/about">About</router-link> page for the acceptable list of options for Company Type and NAICS code.</p>
    <p v-html="levelFi_Instructions"></p>
    <div class="container mt-5">
      <form @submit.prevent="submit()" class="login-form">
        <div class="form-row">
          <div class="col-sm-4">
            <label class="control-label">Choose CSV File</label>
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <input class="form-control-file" type="file" @change="fileChange($event)">
            </div>
          </div>
        </div>
        <div v-if="errorMessage" class="form-row">
          <div class="col-sm-8 offset-sm-4">
            <div class="error-message">{{errorMessage}}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-8 offset-sm-4">
            <button type="submit" class="btn btn-primary mt-3">Submit to LevelFi</button>
            <div v-if="levelfi_result_status  === 'pending'">
              <p style="color:#008000;" > Processing ... </p>
            </div>
          </div>
        </div>
      </form>

    </div>
    <!--    End of Container -->

    <!-- Table Beginning  -->

    <div style="width: 1200px" v-if="params.data">
      <p></p>
      <p> Check the Checkboxes on the far left to select the leads you would like to refer to LiftFund. A record must contain a First Name, Last Name, Phone, and Email to refer the lead.</p>
      <p v-html="Batch_levelFi_Instructions"></p>
      <div class="table">
        <vue-table-dynamic :params="params" ref="table" @select="onSelect"
                           @selection-change="onSelectionChange" @cell-change="onCellChange">
        </vue-table-dynamic>
      </div>


      <!-- Sends Leads to LiftFund -->
      <div v-if="partner_type != 'manual_submit'" >
        <div v-if="batchErrorMessage" class="form-row">
          <div class="form-row">
            <div class="error-message">{{batchErrorMessage}}</div>
          </div>
        </div>
        <button @click="SendToCrm()" class="btn btn-primary mt-3">
          Sends Leads to LiftFund
        </button>
        <div v-if="submit_result === 'Success'" >
          <p style="color:#008000;" > Leads Submitted! </p>
        </div>
        <div v-if="submit_result === 'Pending'" >
          <p style="color:#008000;" > Pending... </p>
        </div>
      </div>

      <!-- Download Button -->
      <button @click="SaveFile()" class="btn btn-primary mt-3">
        Download
      </button>
    </div>


    <!-- end of the table -->


    <!--end of the page  -->
  </div>

</template>


<script>
import DateFn from "date-fns";

import API from "@/services/api";
import PartnerTypeSupport from "@/services/partnertypesupport";
import CSVManager from "@/services/csvmanager";
import { AliasAndCalculateTable, FieldAliases } from "@/services/paramprocessor";
import VueTableDynamic from 'vue-table-dynamic';

export default {
  data() {
    return {
      csvfile: null,
      errorMessage: undefined,
      batchErrorMessage: undefined,
      tableStatus: false,
      parsed: undefined,
      aliased: undefined,
      calculated_fields: undefined,
      table_data: undefined,
      partner_type: undefined,
      partner_name: undefined,
      levelFi_Instructions: undefined,
      Batch_levelFi_Instructions: undefined,
      partner_email: undefined,
      levelFi_Header: undefined,
      submit_result: undefined,
      usage_payload: undefined,
      batch_csv_data: undefined,
      levelfi_result_status: undefined,
      crm_result: undefined,
      params: {
        data: null,
        header: 'row',
        border: true,
        stripe: true,
        // pageSize should only allow 50 rows per page
        pageSize: 50,
        showCheck: true,
        columnWidth: [
          {column: 0, width: 80},
          {column: 1, width: 80},
          {column: 3, width: 130},
          {column: 4, width: 250},
          {column: 5, width: 130},
          {column: 6, width: 130},
          {column: 7, width: 130},
          {column: 8, width: 130},
        ],
        edit: {
          // row: [1],
          column: [5, 6, 7, 8],
          // cell: [[-1, -1]]
        }
      }

    };
  },
  components: { VueTableDynamic },
  mounted() {
    // Boot to login if not logged in
    if (!API.token) {
      this.$router.replace("/login");
    }

    /// Get the name of the user
    this.partner_name = API.GetPartnerName();

    /// Set the partner type in the data object
    this.partner_type= API.GetPartnerType();

    /// Set the partner type in the data object
    this.partner_email= API.GetPartnerEmail();

    /// Setting the Partner Type will populate the approprate text
    PartnerTypeSupport.SetPartnerText(this.partner_type);

    this.levelFi_Instructions = PartnerTypeSupport.levelFi_Instructions;
    this.Batch_levelFi_Instructions = PartnerTypeSupport.Batch_levelFi_Instructions;

    /// Attempt to get the partner name from the email cuz i'm lazy and hate work
    let partner_name;
    try{
      partner_name = this.partner_email.split("@")[1].split(".")[0];
    } catch (error) {
      partner_name = this.partner_email
    }

    // Create a usage record
    this.usage_payload = {
      "referral_name": this.partner_name,
      "referral_email" : this.partner_email,
      "partner_name" : partner_name,
      "partner_type": this.partner_type
    };

  },
  methods: {
    onCellChange (rowIndex, columnIndex, data) {

    },
    onSelect (isChecked, index, data) {

    },
    onSelectionChange (checkedDatas, checkedIndexs, checkedNum) {

    },

    async SendToCrm() {
      this.batchErrorMessage = undefined;
      let checkedData= this.$refs.table.getCheckedRowDatas(true);


      if (checkedData.length === 0){
        this.batchErrorMessage = "No Records were selected. Please check the checkboxes on the far right to select leads to refer."
        return
      }

      // If there is an empty string within a row of data, return false else true
      function findMissingData(my_arr){
        let rowMissingData = [];
        //// Loop through the outer list skipping the header row
        for(let i = 1; i < my_arr.length; i++) {
          let this_record = my_arr[i];
          /// Loop though each record array
          for(let j = 0; j < this_record.length; j++) {
            if(this_record[j] === ""){
              if(rowMissingData.indexOf(this_record[0]) === -1){
                rowMissingData.push(this_record[0]);
              }

            }
          }

        } /// End of Outer Loop
        return(rowMissingData);
      };

      let incompleteRows = findMissingData(checkedData);

      if(incompleteRows.length > 0){
        this.batchErrorMessage = "It looks like Record IDs " + incompleteRows.toString() + " are missing data. Make sure they have all their contact info."
        return
      }


      try {
        /// Let the user know we are working on it
        this.submit_result = "Pending";

        let checkedIndexs = this.$refs.table.getCheckedRowIndexs(true);

        /// Get the Index of the data in the table
        let iFirstName = checkedData[0].indexOf('First Name');
        let iLastName = checkedData[0].indexOf('Last Name');
        let iAppEmail = checkedData[0].indexOf('Applicant Email');
        let iAppPhone = checkedData[0].indexOf('Applicant Phone');
        let iScore = checkedData[0].indexOf('Score');
        /// Get the table data
        this.table_data = this.$refs.table.getData();

        //// Prep the body data
        //// Prep Lead data
        let payload = {};

        /// Attempt to get the partner name from the email cuz i'm lazy and hate work
        let partner_name;
        let split_partner_name;
        try{
          split_partner_name = this.partner_email.split("@")[1].split(".")[0];

          if(split_partner_name === 'suncoastcreditunion') {
            this.partner_name = 'Suncoast Credit Union'
          }

          // Bank of America
          if(split_partner_name === 'bofa') {
            this.partner_name = 'Bank of America'
          }

          // Wells Fargo
          if(split_partner_name === 'wf') {
            this.partner_name = 'Wells Fargo'
          }

          // Goldman Sachs
          if(split_partner_name === 'gsbank') {
            this.partner_name = 'Goldman Sachs'
          }

          // The Village Resource Group
          if (split_partner_name === "thevillageresourcegroup") {
            this.partner_name = "The Village Resource Group";
          }

          // Liftfund
          if(split_partner_name === 'liftfund') {
            this.partner_name = 'Liftfund'
          }

        } catch (error) {
          partner_name = this.partner_email
        }

        let referral_name;
        this.referral_name = API.GetPartnerName();

        payload['data'] = [];
        // payload['record_id'] = "record_id";
        // payload['partner_name'] = partner_name;
        // payload['referral_name'] = this.partner_name;
        // payload['referral_email'] = this.partner_email;
        // payload['partner_type'] = this.partner_type;
        payload['record_id'] = "record_id";
        // Named referral_name, but this is equivalent right now in CRM to Lead Source Detail or the Business Name
        payload['referral_name'] = this.partner_name;
        payload['referral_email'] = this.partner_email;
        payload['partner_type'] = this.partner_type;
        // this partner_name is equivalent to the agent of the company's name, so for example Melva who works at Suncoast
        payload['partner_name'] = this.referral_name;

        for (let i = 1; i < this.table_data.length; i++) {

          /// Check to see if this index is checked this data to LF
          if (checkedIndexs.indexOf(i) === -1) {
            continue
          }

          let individualDataArr = this.table_data[i];

          /// Add in the


          ///// Prep Data for LevelFi SubRecord


          //// Prep the model data
          /// Limit the data based on the Partner Type
          if (this.partner_type === "partial_submit") {
            var record_payload = {};

            /// ADD in contact data
            record_payload['firstname'] = this.table_data[i][iFirstName];
            record_payload['lastname'] = this.table_data[i][iLastName];
            record_payload['email'] = this.table_data[i][iAppEmail];
            record_payload['phone'] = this.table_data[i][iAppPhone];


          } else if (this.partner_type === "complete_submit") {

            /// This needs to be negitive one indexed because the aliased data only has records and no header
            var record_payload = this.aliased[i - 1];

            //// Rename these fields
            record_payload['firstname'] = record_payload['first_name'];
            record_payload['lastname'] = record_payload['last_name'];
            record_payload['email'] = record_payload['email_address'];
            record_payload['phone'] = record_payload['applicant_phone'];


            delete record_payload['first_name'];
            delete record_payload['last_name'];
            delete record_payload['email_address'];
            delete record_payload['applicant_phone'];



          } /// End of Limit based on Partner Type



          /// Prep the LevelFi Business Logic data from the recomendation
          record_payload['score'] = this.table_data[i][iScore];


          /// This idex is one less than the index used in table data because table data has a header
          record_payload['record_id'] = this.parsed[i - 1]['Record ID'];

          record_payload['risk_level'] = this.calculated_fields[i - 1].risk_level;
          record_payload['ten_amount_levelfi'] = this.calculated_fields[i - 1].ten_amount_levelfi;
          record_payload['ten_amount_cf'] = this.calculated_fields[i - 1].ten_amount_cf;
          record_payload['ten_amountfico'] = this.calculated_fields[i - 1].ten_amountfico;



          /// If it is a complete submitter, add in debt and cashflow data
          if (this.partner_type === "complete_submit") {
            /// Grab the Monthly Personal Debt from the user input
            record_payload['_personaldebt'] = Number(this.parsed[i - 1]['Monthly Personal Debt'])


          }
          ; // End of partner type check for complete submitter


          /// Add in the record data to to our payload
          payload['data'].push(record_payload);

        } /// End of Loop through checked data


        /// Send data to the endpoint and see what happens

        this.crm_result = await API.crmPassthroughCongito(payload);

        if(this.crm_result.status === 200,
        this.crm_result.data.body.length > 0){
          this.submit_result = "Success"
        } else {
          this.errorMessage_crm = "There was an error submitting leads. Please Try again or contact support at _____@liftfund.com"
        }

      }  catch (err) {
        this.errorMessage_crm = err.message;
      }


      /// Collect


    }, /// End of on Data Submit

    SaveFile() {
      const csv = CSVManager.GenerateBatchCSV(this.batch_csv_data);
      const currenttime = DateFn.format(new Date(), "YYYY-MM-DD, HHmmss");
      API.DownloadFile("LevelFi Batch " + currenttime + ".csv", csv);
    },

    fileChange(event) {
      this.csvfile = event.target.files[0];
    },
    async submit() {
      this.errorMessage = undefined;
      this.levelfi_result_status = 'pending';
      let parsed;
      try {
        if (!this.csvfile.name.toLowerCase().endsWith(".csv")) {
          throw new Error("The upload must be a .csv file");
        }
        try {
          parsed = await CSVManager.ReadFile(this.csvfile);
          /// Save this to be used later
          this.parsed = parsed;

          /// Create a record of this score attempt
          try{
            /// Add in the number of record that were scored
            this.usage_payload['count_levelfi_usage'] = parsed.length;

            await API.createUseageRecord(this.usage_payload);
          }catch (e) {
            console.log(e)
          };
        } catch (err) {
          throw new Error("Unable to parse CSV file");
        }
        const aliased = [];
        for (let i = 0; i < parsed.length; i++) {
          try {
            const alias = AliasAndCalculateTable(parsed[i]);
            aliased.push(alias);

          } catch (err) {
            throw new Error("Error in CSV row " + (i + 2) + ": " + err.message);
          }
        }

        this.aliased = aliased;

        /// Seperate out the contact fields from the model fields
        /// identify the contact Feilds
        // let contact_fields = FieldAliases.filter(function (item) {
        //     return item.contactField == true;
        // }).map(({ modelField }) => modelField);

        const result = await API.QueryModel({
          record_id: "record_id",
          data: aliased,
          first_name: "first_name",
          last_name: "last_name",
          email_address: "email_address",
          applicant_phone: "applicant_phone"
        });

        if (
          result.status === 200 &&
          result.data &&
          result.data.body.predict.length
        ) {

          /// Calculate the Maxed approved Loan Amount
          let batch_calc_data = [];

          /// Need to add in the calculated values into a single object for the GenerateBatchCSV funtion to loop through
          for (let i = 0; i < result.data.body.predict.length; i++) {

            /// Get this alised Data
            let this_aliased = aliased[i];
            // Get this score
            let this_result = result.data.body.predict[i].score;
            /// Prepare payload
            let rec_params = {}
            rec_params.score = result.data.body.predict[i].score;
            rec_params.opp_fico_score = this_aliased.opp_fico_score;
            rec_params.opp_declared_household_income = this_aliased.opp_declared_household_income;
            rec_params.opp_declared_business_expenses = this_aliased.opp_declared_business_expenses;
            rec_params.opp_declared_business_total_income = this_aliased.opp_declared_business_total_income;
            /// this value is deleted after the alised step
            rec_params._personaldebt = this_aliased.opp_declared_household_income * this_aliased.opp_declared_personal_debt_income_ratio
            rec_params.first_name = this_aliased.first_name;
            rec_params.last_name = this_aliased.last_name;
            rec_params.email_address = this_aliased.email_address;
            rec_params.applicant_phone = this_aliased.applicant_phone;
            batch_calc_data.push(rec_params)
          }

          let calculated_fields = await API.getRecommendation({"data": batch_calc_data});
          calculated_fields = calculated_fields.data.body.data;
          this.calculated_fields = calculated_fields;

          let batch_csv_data = [];

          for (let i = 0; i < calculated_fields.length; i++) {
            let this_calculated_fields = calculated_fields[i]
            // Get this score
            let this_result = result.data.body.predict[i].score
            // add to new object
            for (let i = 0; i < batch_calc_data.length; i++) {
              const parsedObj = batch_calc_data[i];
            }

            batch_csv_data.push({
              recordIDs: result.data.body.predict[i].recordIDs,
              score: this_result,
              risk_level: this_calculated_fields.risk_level,
              // ten_amountfico: this_calculated_fields.ten_amountfico,
              // ten_amount_cf: this_calculated_fields.ten_amount_cf,
              rec_levelfi: this_calculated_fields.rec_levelfi,
              ten_amount_levelfi: this_calculated_fields.ten_amount_levelfi,
              first_name: batch_calc_data[i].first_name,
              last_name: batch_calc_data[i].last_name,
              email_address: batch_calc_data[i].email_address,
              applicant_phone: batch_calc_data[i].applicant_phone
            });

          }


          // end of batch_csv_data loop
          let header_row = ['Record ID', 'Score', 'Risk Level', 'Recommendation', 'Tentative Amount Qualified - LevelFi', 'First Name', 'Last Name', 'Applicant Email', 'Applicant Phone']

          let table_data = []
          table_data.push(header_row);
          for (let i = 0; i < batch_csv_data.length; i++) {
            let thisList = Object.values(batch_csv_data[i]);
            table_data.push(thisList);
          }
          this.params.data = table_data;
          this.table_data = table_data;


          /// Save the batch CSV data so it can be saved for thsi button
          this.batch_csv_data = batch_csv_data;
          // const csv = CSVManager.GenerateBatchCSV(batch_csv_data);
          // const currenttime = DateFn.format(new Date(), "YYYY-MM-DD, HHmmss");
          // API.DownloadFile("LevelFi Batch " + currenttime + ".csv", csv);

          /// Show the Table
          this.tableStatus = 'show';

          //// Remove the Pending message
          this.levelfi_result_status = "complete";

        } else {
          throw new Error("Bad response from LevelFi API");
        }
      } catch (err) {
        this.errorMessage = err.message;
      }
    }

  }

};
</script>

<style>

.form-row {
  margin-top: 20px;
}
.error-message {
  color: red;
}
.table {
  border: 2px solid rgb(65, 189, 227);
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Table.vue